import { render, staticRenderFns } from "./ActionRecommendAccept.vue?vue&type=template&id=21b9ddea&"
import script from "./ActionRecommendAccept.vue?vue&type=script&lang=js&"
export * from "./ActionRecommendAccept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports